var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',{attrs:{"title":_vm.title}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[(!_vm.pass)?_c('loading'):_vm._e(),(_vm.pass)?_c('pass-form',{attrs:{"model":_vm.pass}}):_vm._e()],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }